import { useQuery } from "react-query";
import RecipientService from "../../services/recipient-data-service/RecipientDataService";
import { RestError } from "../../services/rest-service/RestService";
import { IRecipientUsageDTO } from "../../services/user-role-administration-service/Models";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseRecipientUsageParameters = {
    groupID: number;
    recipientID: number;
} & BaseUseQueryParameters<Array<IRecipientUsageDTO>>;

export function useRecipientUsage({
    groupID,
    recipientID,
    enabled,
    onError,
    onSuccess
}: UseRecipientUsageParameters) {
    return useQuery<Array<IRecipientUsageDTO>, RestError>(
        keys.usageList(recipientID),
        ({ signal }) => {
            return RecipientService.getRecipientUsage(groupID, recipientID, signal);
        },
        {
            enabled,
            onError,
            onSuccess
        }
    );
}